import { CommonGet, CommonPost } from "../../../utils/CommonFetch";

export default {
    saveField,
    editData,
    getAllDivisionsByEstateID,
    getOperationEntityByType,
    getCollectionPointCategoryIDByEstateID,
    getGroupsForDropdown,
    GetAllEstatesByGroupID,
    getCollectionPointByID,
    getFieldFilterData
};

async function saveField(data){
    let field = {
        fieldID: 0,
        collectionPointID: parseInt(data.collectionPointID),
        fieldCode: data.fieldCode,
        fieldName: data.fieldName,
        fieldLocation: data.fieldLocation,
        createdBy: 0,
        createdDate: new Date().toISOString(),
        modifiedBy: 0,
        modifiedDate: new Date().toISOString(),
        isActive: data.isActive
    };
    const response = await CommonPost('/api/Field/SaveField', null, field);
    return response;
}

async function editData(data) {
    data.collectionPointID = parseInt(data.collectionPointID);
    data.modifiedDate = new Date().toISOString();
    const response = await CommonPost('/api/Field/UpdateField', null, data);
    return response;
}

async function getAllDivisionsByEstateID(estateID) {
    var divisionArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllDivisionsByEstateID', 'estateID=' + estateID);
    for (let item of Object.entries(response.data)) {
        divisionArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        
    }
    return divisionArray;
}

async function getOperationEntityByType(groupID) {
    const dataArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllEstatesByGroupID', 'groupID=' + groupID);
    for (let item of Object.entries(response.data)) {
        if(item[1]["isActive"] === true)
            dataArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return dataArray;
}

async function getCollectionPointByID(id) {
    const response = await CommonGet('/api/CollectionPoint/GetCollectionPointById', 'id=' + id);
    return response.data;
}

async function getCollectionPointCategoryIDByEstateID(estateID) {
    var collectionPointCategoryArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetCollectionPointCategoryIDByEstateID', 'estateID=' + estateID);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            collectionPointCategoryArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return collectionPointCategoryArray;
}

async function getGroupsForDropdown() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllGroups', null)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function GetAllEstatesByGroupID(groupID) {
    var estateArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllEstatesByGroupID', 'groupID=' + groupID)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            estateArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return estateArray;

}

async function getFieldFilterData(data) {
    var filterModel = {
        groupID: data.groupID,
        operationEntityID: data.estateID,
        collectionPointID: data.collectionPointCategoryID
    }
    const response = await CommonPost('/api/Field/FilterField', null, filterModel);
    return response.data;
}



